import OAuthInteraction from 'views/oauth/OAuthInteraction'
import AuthenticationErrorBoundary from 'modules/authentication/components/AuthenticationErrorBoundary/AuthenticationErrorBoundary'
import ErrorBoundaryComponent from 'modules/errorBoundary/components/ErrorBoundaryComponent'
import type { RouteObject } from 'react-router-dom'
import ChooseAccount from 'views/chooseAccount'
import CreateAccount from 'views/createAccount'
import Gateway from 'views/gateway'
import Invite from 'views/invite'
import ManagerTokenInviteProvider from 'views/invite/providers/ManagerTokenInviteProvider'
import Login from 'views/login'
import Register from 'views/register'
import RegisterNewPassword from 'views/registerNewPassword/RegisterNewPassword'
import TwoFactorAuth from 'views/twoFactorAuth/TwoFactorAuth'
import VerificationCode from 'views/verificationCode/VerificationCode'

export const routes: RouteObject[] = [
  { path: '/oauth/interaction/:id', element: <OAuthInteraction /> },
  {
    path: '*',
    element: <Login />
  },
  {
    path: '/choose-account',
    element: (
      <AuthenticationErrorBoundary>
        <ChooseAccount />
      </AuthenticationErrorBoundary>
    )
  },
  {
    path: '/create-account',
    element: (
      <AuthenticationErrorBoundary>
        <CreateAccount />
      </AuthenticationErrorBoundary>
    )
  },
  {
    path: '/register-new-password',
    element: (
      <ErrorBoundaryComponent>
        <RegisterNewPassword />
      </ErrorBoundaryComponent>
    )
  },
  {
    path: '/verification-code',
    element: (
      <ErrorBoundaryComponent>
        <VerificationCode />
      </ErrorBoundaryComponent>
    )
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/invite',
    element: (
      <ErrorBoundaryComponent>
        <ManagerTokenInviteProvider>
          <Invite />
        </ManagerTokenInviteProvider>
      </ErrorBoundaryComponent>
    )
  },
  {
    path: '/2fa',
    element: (
      <ErrorBoundaryComponent>
        <TwoFactorAuth />
      </ErrorBoundaryComponent>
    )
  }
]
